module.exports = __webpack_public_path__ + "static/img/100000Pkg.4ac7940.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/100000Pkg.png
// module id = +lJ1
// module chunks = 0